// @ai-generated 2026-06-05T09:19:06+00:00 by niklas.eicker@tngtech.com using Claude Sonnet 4.6
import { useMemo } from 'react';
import { type ApiUserPartnershipInformation } from '@Model';
import { useSession } from '@Contexts/session/SessionContext';

/**
 * Returns the partnership the user is currently acting in, or undefined if it cannot be resolved yet.
 */
export function useCurrentPartnership(): ApiUserPartnershipInformation | undefined {
    const {
        current: { partnershipId },
        partnerships,
    } = useSession();

    return useMemo(() => partnerships.find((p) => p.partnership_id === partnershipId), [partnerships, partnershipId]);
}
